import { WithdrawAction } from './action.model';

export class StaticUserData {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    country: string;
    merchant: string;

    constructor(actions: WithdrawAction[]) {
        const metadata: { [key: string]: string } = actions.find(
            (action) => action.status === 'CREATED'
        ).metadata;

        this.userId = metadata.userid;
        this.email = metadata.email;
        this.firstName = metadata.firstName;
        this.lastName = metadata.lastName;
        this.country = metadata.country;
        this.merchant = metadata.merchant;
    }
}
